import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../api/axios";

const Star = ({ filled, onClick }) => (
  <span
    role="button"
    onClick={onClick}
    style={{ fontSize: 24, cursor: "pointer" }}
    aria-label={filled ? "star filled" : "star empty"}
  >
    {filled ? "★" : "☆"}
  </span>
);

const ReviewModal = ({ show, onHide, claimId, onSaved }) => {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const submit = async () => {
    if (!claimId) return;
    setLoading(true);
    try {
      /* await api.post(
        "/reviews",
        { claimId, rating, comment },
        { headers: { Authorization: `Bearer ${token}` } }
      ); */
       await api.post("/reviews", { claim_id: claimId, rating, comment }, {
   headers: { Authorization: `Bearer ${token}` }
});
      
      onSaved?.(); // para refrescar la lista
      onHide();
    } catch (err) {
      console.error("Error al crear reseña:", err.response?.status, err.response?.data || err.message);
      onHide();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Dejar reseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3 d-flex gap-1">
          {[1, 2, 3, 4, 5].map((n) => (
            <Star key={n} filled={n <= rating} onClick={() => setRating(n)} />
          ))}
        </div>
        <Form.Group className="mb-2">
          <Form.Label>Comentario (opcional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            maxLength={600}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Contanos tu experiencia…"
          />
          <Form.Text className="text-muted">
            Máx. 600 caracteres.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={submit} disabled={loading || !rating}>
          Publicar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReviewModal;
